import { QuestelServicesClient, RequestResult } from '@questelservices/common';
import store from '@/store';
import { EpAttorney } from '@/models/EpAttorneys/EpAttorney';

export class EpAttorneyService {
  private client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, "/api");
  }

  public async getEpAttorneyList(): Promise<EpAttorney[]> {
    return await this.client.get<EpAttorney[]>(`/v1/EPAttorney`);
  }
}